import * as DomUtility from '@sparta.global.utilities/dom-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

/**
 *
 * @class CommonAutoUtility
 */
class CommonAutoUtility {
  /**
   * Checks if the value passed in is valid state. Returns "VA" if no state is passed
   * in (in the case of international addresses) OR if the state is a military address
   * @param {String} state: string (a 2 letter state code or empty string), null, or undefinded
   * @returns {string}: string - a 2 letter state code
   */
  checkIfInternationalOrMilitaryAddress(state) {
    if (!state || state === 'AA' || state === 'AE' || state === 'AP') {
      return 'VA';
    }
    return state;
  }

  /**
   * Toggles content visibility
   * @param {string} item - wrapping element for toggle link
   * @param {string} link - toggle link
   * @param {string} container - content that needs to be toggled
   * @param {string|object} target -  DOM NodeList or selector to use as scope
   * @returns {undefined}
   */
  toggleContent(item, link, container, target) {
    const toggleActiveClass = () => {
      const itemContainer = DomUtility.findEl(item, target);
      const itemLink = DomUtility.findEl(link, target);
      const contentContainer = DomUtility.findEl(container, target);
      itemContainer.classList.toggle('active');
      if (contentContainer) {
        if (itemContainer.classList.contains('active')) {
          contentContainer.setAttribute('aria-hidden', false);
          itemLink.setAttribute('aria-expanded', 'true');
        } else {
          contentContainer.setAttribute('aria-hidden', true);
          itemLink.setAttribute('aria-expanded', 'false');
        }
      }
    };
    DomUtility.delegateEvent('click', link, target, toggleActiveClass);
  }

  /**
   * To retain input values between pages
   * @param {jQuery} $inputs: JQ object
   * @returns {undefined}
   */
  retainInputValues($inputs) {
    $.each($inputs, function () {
      $(this).on('blur', function () {
        sessionStorage.setItem(this.id, $(this).val());
      });
    });

    // if a key value pair exists for each input's id, prepopulate that field with value
    $.each($inputs, function () {
      var storedValue = sessionStorage.getItem(this.id);
      // if the stored Value is empty or null, don't do anything
      if (storedValue !== "" && storedValue !== null) {
        $(this).val(sessionStorage.getItem(this.id));
        $(this).parent().removeClass('spa-input--empty');
      }
    });
  }
}
var index = new CommonAutoUtility();

export { index as default };
